import React from "react";
import { TextField, InputAdornment, IconButton } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";

// Shared filter-toolbar styling for the campaign status tabs (Payment Queue,
// Waiting, Success, …) so every tab's search and dropdowns look the same.
export const filterInputSx = {
  "& .MuiOutlinedInput-root": {
    height: 40,
    backgroundColor: "#fff",
    borderRadius: 1.5,

    "& fieldset": {
      borderColor: "#d1d5db",
    },

    "&:hover fieldset": {
      borderColor: "#832ccf",
    },

    "&.Mui-focused fieldset": {
      borderColor: "#832ccf",
      borderWidth: "1px",
    },
  },
};

export const filterSelectSx = {
  ...filterInputSx,
  "& .MuiInputLabel-root": { fontSize: "14px" },
  "& .MuiInputLabel-root.Mui-focused": { color: "#832ccf" },
  "& .MuiSelect-select": { fontSize: "14px" },
};

export default function SearchField({ value, onChange, placeholder, ariaLabel }) {
  return (
    <TextField
      size="small"
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      inputProps={{ "aria-label": ariaLabel || placeholder }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon sx={{ fontSize: 21, color: "#6b7280" }} />
          </InputAdornment>
        ),
        endAdornment: value && (
          <InputAdornment position="end">
            <IconButton
              size="small"
              aria-label="Clear search"
              edge="end"
              onClick={() => onChange("")}
            >
              <ClearIcon sx={{ fontSize: 16 }} />
            </IconButton>
          </InputAdornment>
        ),
      }}
      sx={{
        width: { xs: "100%", sm: 240 },
        ...filterInputSx,
        "& .MuiInputBase-input": {
          color: "#111827",
          fontSize: "14px",
        },
        "& .MuiInputBase-input::placeholder": {
          color: "#6b7280",
          opacity: 1,
        },
      }}
    />
  );
}
